import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
} from "@mui/material";
import numeral from "numeral";
import React, { useState } from "react";
import useAuth from "../../contexts/UserContext.tsx";
import { IndividualStudentProgressWidget } from "../IndividualStudentProgressWidget.jsx";
import studentImage from "../../assets/student.jpg";
import EditOffIcon from "@mui/icons-material/EditOff";
import EditNoteIcon from "@mui/icons-material/EditNote";
import FitnessCenterIcon from "@mui/icons-material/FitnessCenter";
import LibraryAddCheckIcon from "@mui/icons-material/LibraryAddCheck";

const columns = [
  { id: "name", label: "Name" },
  {
    id: "notstarted",
    label: (
      <EditOffIcon
        className="icon"
        style={{
          backgroundColor: "#eab80f",
          color: "white",
          fontSize: "2.5rem",
        }}
      />
    ),
  },
  {
    id: "started",
    label: (
      <EditNoteIcon
        className="icon"
        style={{
          backgroundColor: "rgb(15,158,234)",
          color: "white",
          fontSize: "2.5rem",
        }}
      />
    ),
  },
  {
    id: "struggling",
    label: (
      <FitnessCenterIcon
        className="icon"
        style={{
          backgroundColor: "#ea271a",
          color: "white",
          fontSize: "2.5rem",
        }}
      />
    ),
  },
  {
    id: "completed",
    label: (
      <LibraryAddCheckIcon
        className="icon"
        style={{
          backgroundColor: "rgba(0, 128, 0, 0.2)",
          color: "green",
          fontSize: "2.5rem",
        }}
      />
    ),
  },
];

export const StudentProgressDataTable = ({ studentDetails, course }) => {
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState(columns[0].id);
  const { user } = useAuth();
  const [individualStudentDetails, setIndividualStudentDetails] = useState();
  const schoolID = user.view_access_list.schoolID;

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  function getComparator(order, orderBy) {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleIndividualSelection = (studentID, studentName) => {
    setIndividualStudentDetails({
      studentID,
      studentName,
      course,
    });
  };

  return (
    <div className="flex">
      <div className="max-w-[50%]">
        <TableContainer
          component={Paper}
          className="tableContainer shadow-md m-1 overflow-y-scroll h-[calc(100vh-80px)]"
        >
          <div className="tableTitle text-xl">Student Progress for school</div>
          <Table id="summary" className="mb-0">
            <TableHead>
              <TableRow>
                {columns.map((column) => {
                  return (
                    <TableCell key={column.id}>
                      <TableSortLabel
                        active={orderBy === column.id}
                        direction={orderBy === column.id ? order : "asc"}
                        onClick={(event) => handleRequestSort(event, column.id)}
                      >
                        {column.label}
                      </TableSortLabel>
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>

            <TableBody>
              {studentDetails &&
                stableSort(studentDetails, getComparator(order, orderBy)).map(
                  (row) => {
                    return (
                      <TableRow key={row.user_id}>
                        <TableCell>
                          {/* <Link
                            to={`${individualProgressURL}/${course}/${row.name}/${row.user_id}`}
                          > */}
                          <span
                            onClick={() =>
                              handleIndividualSelection(row.user_id, row.name)
                            }
                            className="text-[#8884d8] hover:underline cursor-pointer"
                          >
                            {row.name}
                          </span>
                          {/* </Link> */}
                        </TableCell>

                        <TableCell>
                          {row.notstarted > 1000 ? (
                            <span style={{}}>
                              {numeral(row.notstarted).format("0.0a")}
                            </span>
                          ) : (
                            <span style={{}}>{row.notstarted}</span>
                          )}
                        </TableCell>
                        <TableCell>
                          {row.started > 1000 ? (
                            <span style={{}}>
                              {numeral(row.started).format("0.0a")}
                            </span>
                          ) : (
                            <span style={{}}>{row.started}</span>
                          )}
                        </TableCell>
                        <TableCell>
                          {row.struggling > 1000 ? (
                            <span style={{}}>
                              {numeral(row.struggling).format("0.0a")}
                            </span>
                          ) : (
                            <span style={{}}>{row.struggling}</span>
                          )}
                        </TableCell>
                        <TableCell>
                          {row.completed > 1000 ? (
                            <span style={{}}>
                              {numeral(row.completed).format("0.0a")}
                            </span>
                          ) : (
                            <span style={{}}>{row.completed}</span>
                          )}
                        </TableCell>
                      </TableRow>
                    );
                  }
                )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      {individualStudentDetails && (
        <IndividualStudentProgressWidget
          individualStudentDetails={individualStudentDetails}
          schoolID={schoolID}
        />
      )}
      {!individualStudentDetails && (
        <TableContainer
          component={Paper}
          className="mt-1 mx-2 flex flex-col justify-center items-center"
        >
          <img
            src={studentImage}
            alt="student"
            className="flex justify-center w-80 aspect-square"
          />
          <p className="w-40 text-center font-medium text-xl">
            Select a student to view progress
          </p>
        </TableContainer>
      )}
    </div>
  );
};
